/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';
require('../vendor/validate.js');

export function contactForm() {

  $('input').on('focus', function () {
    $(this)
      .closest('.gfield')
      .addClass('focused');
  });

  $('input').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .closest('.gfield')
        .removeClass('focused');
    }
  });

  $('textarea').on('focus', function () {
    $(this)
      .closest('.gfield')
      .addClass('focused');
  });

  $('textarea').on('blur', function () {
    if ($(this).val() === '') {
      $(this)
        .closest('.gfield')
        .removeClass('focused');
    }
  });

}
